type NearestPowerResult = {
  denominator: number
  prefix: string
  value: number | null
}

const powers = {
  giga: { prefix: 'G', denominator: 10 ** 9 },
  mega: { prefix: 'M', denominator: 10 ** 6 },
  kilo: { prefix: 'k', denominator: 10 ** 3 },
  unit: { prefix: '', denominator: 1 },
}

const calculateNearestPower = (
  value: number | null,
  power: (typeof powers)[keyof typeof powers],
): NearestPowerResult => {
  return {
    ...power,
    value: value === null ? null : Math.floor(value / power.denominator),
  }
}

export const toNearestPower = (value: number | null): NearestPowerResult => {
  if (value !== null) {
    if (value >= powers.giga.denominator)
      return calculateNearestPower(value, powers.giga)
    if (value >= powers.mega.denominator)
      return calculateNearestPower(value, powers.mega)
    if (value >= powers.kilo.denominator)
      return calculateNearestPower(value, powers.kilo)
  }
  return calculateNearestPower(value, powers.unit)
}
